module.exports = __webpack_public_path__ + "static/media/gmail-body-correct.4662cda3.png";